import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AuthActions } from 'common/config/store';
import history from 'app-router/history';

const LoginSSO: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      AuthActions.checkLoginAction((result) => {
        if (!result.cancelled && !result.error) {
          history.push('/');
        } else {
          history.push('/login');
        }
      })
    );
  }, [dispatch]);

  return null;
};
export default LoginSSO;
